import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { FIELD_OPS_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { LeaveApplicationListPage } from '@/features/leaveApplications/pages/LeaveApplicationListPage';
import { leaveApplicationSearchSchema } from '@/features/leaveApplications/types/filters.types';

export const Route = createFileRoute('/_auth/hr-form/leave-applications/')({
  validateSearch: leaveApplicationSearchSchema,
  beforeLoad: () => requirePermission(FIELD_OPS_PERMISSIONS.LEAVE_VIEW),
  component: () => (
    <ErrorBoundary moduleName="Leave Applications">
      <Suspense fallback={<PageLoader />}>
        <LeaveApplicationListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
